import { ApiService } from "./../../services/api.service";
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { Ask, AskWithUpdates, CompanyDepth, CompanyDepthWithUpdates } from "src/app/models/company-depth";
import { SignalRService } from "src/app/services/signalr.service";
import { SharedService } from "src/app/services/shared.service";
import { CompanyList, CompanyListWithUpdates } from "src/app/models/company-list";
import { TranslateService } from "@ngx-translate/core";
import { OrderBuyComponent } from "../order-buy/order-buy.component";
import { MatDialog } from "@angular/material/dialog";
import { AccountService } from "src/app/services/account.service";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import { UrlConstants } from "src/app/models/urlConstants";
import { MatTableDataSource } from "@angular/material/table";
import { CompanyDetails } from "src/app/models/company-details";


@Component({
  selector: "app-market-depth",
  templateUrl: "./market-depth.component.html",
  styleUrls: ["./market-depth.component.scss"],
})
export class MarketDepthComponent implements OnInit {
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input("companyName") companyName: string;
  @Input() isLinked: boolean;

  isDepthLoading: boolean = false;
  companyDepth: CompanyDepthWithUpdates;
  searchCompWithUpdates = new MatTableDataSource<CompanyListWithUpdates>();
  companyData: CompanyList;
  isOrder: boolean = false;
  isDarkTheme: boolean;
  companyDetails: CompanyDetails;
  isLoading=false;
  companies: CompanyList[] = [];
  toggleBool: boolean;
  records: CompanyList[] = [];
  searchValue: string;

  isAllDepthView: boolean = false;

  private depthConnection: HubConnection;
  allDepth: CompanyDepthWithUpdates;

  flashingVolumeNumber: string;
  flashingOrderNumber: string;
  flashingPriceNumber: string;
  flashingType: string;
  isFlashing: boolean = false;
  flashingIndex: number | null = null;
  flashDirection: 'up' | 'down' | null = null;
  previousValues: { [key: number]: { orderPrice: number; volumeTraded: number } } = {};
  previousCompanyDepth: CompanyDepthWithUpdates | null = null;
  isMarket:boolean;
  constructor(
    private _service: ApiService,
    signalService: SignalRService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    public accService: AccountService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) { 
    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });
    signalService.marketChanges.subscribe((res) => {
        res.forEach((update) => {
              if (update.SYMBOL_CODE == this.symbolCode) {
                this.companyData = update}})});
  }
    get numberFormat(): string {
    const digits = this.companyDetails?.RoundDigits != null ? this.companyDetails.RoundDigits : 3;
    return `1.${digits}-${digits}`;
  }
  connectSignalR() {
    this.depthConnection = new HubConnectionBuilder()
      .withUrl(UrlConstants.newSignalR + "/bidsAsksHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    this.startConnection();
  }

  startConnection() {
    try {
      this.depthConnection.start().then(() => {
        this.depthConnection.invoke("JoinGroup", this.symbolCode);

        this.depthConnection.on("sendBidsAsksForSymbol", (depthUpdate) => {
          this.updateMarketDepth(depthUpdate);
        });
      });
    } catch (err) {
      setTimeout(() => this.startConnection(), 50);  // Retry after 5 seconds
    }
  }

  updateMarketDepth(depthUpdate) {
    let update = depthUpdate[0]["MarketDepth"] as CompanyDepthWithUpdates;
    const updatedAsks = update.asksPerPrice;
    const updatedBids = update.bidsPerPrice;

    this.processFlashingLogic(updatedAsks, updatedBids);
    this.companyDepth.totalsBidsAndAsks.TOTAL_ASKS = update.totalsBidsAndAsks.TOTAL_ASKS;
    this.companyDepth.totalsBidsAndAsks.TOTAL_BIDS = update.totalsBidsAndAsks.TOTAL_BIDS;
    this.companyDepth.asksPerPrice = updatedAsks;
    this.companyDepth.bidsPerPrice = updatedBids;

    this.previousCompanyDepth = JSON.parse(JSON.stringify(this.companyDepth));
  }

  processFlashingLogic(updatedAsks: AskWithUpdates[], updatedBids: AskWithUpdates[]) {
    if (!this.previousCompanyDepth) return;

    this.processUpdates(updatedAsks, this.previousCompanyDepth.asksPerPrice, 'asks');
    this.processUpdates(updatedBids, this.previousCompanyDepth.bidsPerPrice, 'bids');
  }

  processUpdates(newDataList: AskWithUpdates[], oldDataList: AskWithUpdates[], type: string) {
    for (let index = 0; index < newDataList.length; index++) {
      const newData = newDataList[index];
      const oldData = oldDataList[index];

      if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
        this.applyNewFlashLogic(newData, oldData);
      }
    }
  }

  applyNewFlashLogic(newData, oldData) {
    if (JSON.stringify(newData) === JSON.stringify(oldData)) {
      return;
    }

    if (newData.ORDER_PRICE !== oldData.ORDER_PRICE) {
      if (newData.ORDER_PRICE > oldData.ORDER_PRICE) {
        newData.ORDER_PRICE_UPDATED = 2;
      } else if (newData.ORDER_PRICE < oldData.ORDER_PRICE) {
        newData.ORDER_PRICE_UPDATED = 1;
      } else {
        newData.ORDER_PRICE_UPDATED = 0;
      }
    }

    if (newData.VOLUME_TRADED !== oldData.VOLUME_TRADED) {
      if (newData.VOLUME_TRADED > oldData.VOLUME_TRADED) {
        newData.VOLUME_TRADED_UPDATED = 2;
      } else if (newData.VOLUME_TRADED < oldData.VOLUME_TRADED) {
        newData.VOLUME_TRADED_UPDATED = 1;
      } else {
        newData.VOLUME_TRADED_UPDATED = 0;
      }
    }

    if (newData.split !== oldData.split) {
      if (newData.split > oldData.split) {
        newData.split_UPDATED = 2;
      } else if (newData.split < oldData.split) {
        newData.split_UPDATED = 1;
      } else {
        newData.split_UPDATED = 0;
      }
    }
  }

  flashingData: { index: number; flashType: string; type: string; direction: string; volume?: string; price?: string; order?: string }[] = [];

  applyFlashLogic(newData, oldData, index, type) {
    const flashData: {
      index: number;
      type: string;
      direction: string | null;
      volume: string | null;
      price: string | null;
      order: string | null;
      flashType: string | null;
    } = { index, type, direction: null, volume: null, price: null, order: null, flashType: null };

    const checkChange = (newValue, oldValue, key) => {
      if (newValue !== oldValue) {
        flashData[key] = (Math.abs(newValue - oldValue)).toFixed(2).toString();
        flashData.direction = newValue > oldValue ? 'up' : 'down';
        flashData.flashType = key;
        this.triggerFlash(flashData, index, flashData.flashType);
      }
    };
    checkChange(newData.VOLUME_TRADED, oldData.VOLUME_TRADED, 'volume');
    checkChange(newData.ORDER_PRICE, oldData.ORDER_PRICE, 'price');
    checkChange(newData.split, oldData.split, 'order');
  }

  triggerFlash(flashData, index, flashType) {
    this.flashingData.push({ index, flashType, direction: flashData.direction, ...flashData });
    this.cdr.detectChanges();
    setTimeout(() => {
      this.removeFlash(index, flashType);
    }, 1000);
  }

  removeFlash(index: number, flashType: string) {
    this.flashingData = this.flashingData.filter(flash => flash.index !== index || flash.flashType !== flashType);
    this.cdr.detectChanges();
  }

  isFlashingIndex(index: number, flashType: string, type: string, direction: string): boolean {
    return this.flashingData.some(flash => flash.index === index && flash.flashType === flashType && flash.type === type && flash.direction === direction);
  }

  getFlashingNumber(index: number, type: string): string | null {
    const flash = this.flashingData.find(flash => flash.index === index && flash.type === type);
    return flash ? flash[type] : null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.reuters) {
      this.symbolCode = changes?.symbolCode?.currentValue;
      this.reuters = changes.reuters?.currentValue;
      this.fetchSymbolBO();
    }
    if (this.symbolCode) {
      this.companyDepth = null;
      this.isDepthLoading = true;
      if (this.isOrder) this.fetchDepthByOrder();
      else this.fetchDepthByPrice();

      this.fetchSymbolBO();
    }
    this.companies = this.sharedService.allMarketCompanies;

    if (!this.isOrder && this.symbolCode) {
      if (this.depthConnection) this.depthConnection.stop();
      this.connectSignalR();
    }
  }

  ngOnDestroy(): void {
    if (this.depthConnection) this.depthConnection.stop();
  }

  toggleOrderView(value) {
    if (this.symbolCode) this.isDepthLoading = true;
    this.isOrder = value;
    if (value) this.fetchDepthByOrder();
    else this.fetchDepthByPrice();
  }

  fetchDepthByOrder() {
    this._service.fetchDepthByOrder(this.symbolCode).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepthWithUpdates;
    });
  }

  fetchDepthByPrice() {
    this._service.fetchDepthByPrice(this.symbolCode, 10).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepthWithUpdates;
    });
  }

  switchView() {
    if (!this.isAllDepthView) {
      this.fetchAllDepthByPrice();
      this.isAllDepthView = !this.isAllDepthView;
    } else {
      this.isAllDepthView = !this.isAllDepthView;
    }
  }

  fetchAllDepthByPrice() {
    this._service.fetchDepthByPrice(this.symbolCode, 100).subscribe((res) => {
      this.allDepth = res as CompanyDepthWithUpdates;
    });
  }

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem("darktheme") === "dark";
  }

  credentialsSearchFilter(event: any) {
    const val = event.target.value.toLowerCase();

    this.toggleBool = val !== "";

    this.records = this.companies?.filter(function (d) {
      return (
        d.ENG_NAME?.toLowerCase().includes(val) ||
        d.ARB_NAME?.toLowerCase().includes(val) ||
        d.Reuters?.toLowerCase().includes(val)
      );
    });
  }

  changecompany(record) {
    this.reuters = record.Reuters;
    this.searchValue = null;
    this.symbolCode = record.SYMBOL_CODE;
    this.companyName = this.translate.currentLang === "ar" ? record.ARB_NAME : record.ENG_NAME;

    if (this.isOrder) this.fetchDepthByOrder();
    else this.fetchDepthByPrice();
    this.records = null;
  }

  orderBuy(company, isSell) {
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: {
        symbol: this.symbolCode,
        type: isSell,
        price: company.ORDER_PRICE,
        //qty: isSell? null: company.VOLUME_TRADED,
      },
      direction: this.translate.currentLang === "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
    fetchSymbolBO() {
    if (this.symbolCode) {
      this.isLoading = true;
      this._service
        .fetchSymbolBO(this.symbolCode)
        .subscribe({
          next: (res: CompanyDetails) => {
            this.companyDetails = res;
            this.isLoading = false;
            this.cdr.markForCheck(); // Trigger change detection for numberFormat updates
          },
          error: (err) => {
            this.isLoading = false;
          }
        });
    }
  }
}